import auth from 'features/auth/redux/auth.reducer';
import { combineReducers } from '@reduxjs/toolkit';
import sidebar from 'features/sidebar/redux/sidebar.reducer';
import adminUsers from 'features/admin-users/redux/admin-users.reducer';
import adminRoles from 'features/admin-roles/redux/admin-roles.reducer';
import adminPermissions from 'features/admin-permissions/redux/admin-permissions.reducer';
import adminLogs from 'features/admin-logs/redux/admin-logs.reducer';
import header from 'features/header/redux/header.reducer';
import emailVerificationReducer from 'features/admin-email-verification/redux/email-verification.reducer';
import gcash from 'features/gcash/redux/gcash.reducer';

export default combineReducers({
  auth,
  sidebar,
  header,
  adminUsers,
  adminRoles,
  adminPermissions,
  adminLogs,
  emailVerificationReducer,
  gcash,
});
